<template>
  <v-card class="mx-auto" max-width="1200">
    <v-simple-table v-if="items.length < 1">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="headline py-5" width="20">Таких пользователей не найдено...</th>
          </tr>
        </thead>
      </template>
    </v-simple-table>

    <v-simple-table v-else>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left" width="20"></th>
            <th class="text-left">Логин</th>
            <th class="text-left">Клуб</th>
          </tr>
        </thead>

        <tbody v-if="hasItems">
          <tr v-for="(item, index) in items" :key="index">
            <td>
              <router-link :to="{ name: 'users__id',  params: { id: item.id } }"> {{ item.id }}
              </router-link>
            </td>
            <td class="py-1">
              <v-img :src="item.photo" width="50" height="50" style="border-radius: 50%;"></v-img>
            </td>

            <td> {{ item.login }} </td>
            <td> {{ item.club ? item.club.name: '' }} </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import notify from '@/mixins/notify'

// import LoginAsUserGQL from '@/graphql/private/LoginAsUser.gql'

export default {
  props: {
    items: {
      type: Array,
      default: () => [{
        id: 'qwemcd112',
        name: 'Maximillian',
        username: 'meloman',
        avatar: 'https://randomuser.me/api/portraits/men/97.jpg'
      }]
    }
  },

  mixins: [notify],

  computed: {
    hasItems() {
      return this.items.length > 0
    }

    //   computedItems () {
    //     return this.items.map(item => {
    //       if (item.published === true || item.published === 'Да') {
    //         item.published = 'Да'
    //       } else {
    //         item.published = 'Нет'
    //       }

    //       const publishDate = +item.publishDate

    //       if (!publishDate) {
    //         return item
    //       }

    //       item.publishDate = new Date(+item.publishDate).toISOString().substr(0, 10)

  //       return item
  //     })
  //   }
  },

  methods: {
  //   async loginByUser(userId) {
  //     try {
  //       const result = await this.$apollo.mutate({
  //         mutation: LoginAsUserGQL,
  //         variables: {
  //           id: userId
  //         }
  //       })
  //
  //       window.open(`${process.env.VUE_APP_WWP_LINK}/login?token=${result.data.loginAsUser.access_token}`, '_blank')
  //     } catch (err) {
  //       this.notify({
  //         text: 'Не получилось сгенерировать токен',
  //         type: 'error'
  //       })
  //       throw new Error(err)
  //     }
  //   }
  }
}
</script>
